module.exports = __webpack_public_path__ + "img/HS-16.8b58341e.jpg";